import { ApiGetData } from 'api/get';

export const GetData = language => dispatch => {
  ApiGetData(language)
    .then(res => {
      //console.log(res)
      dispatch({ type: 'GETDATA', data: res.data });
      dispatch({ type: 'LANGUAGE', language: language });
      localStorage.setItem('language', language);
    })
    .catch(err => {});
};
